import ChatInput from "./ChatInput";

export type { ChatInputHandle, ChatInputParams } from "./ChatInput";
export default ChatInput;
